<div (click)="processDownloadReport()" class="card-box" style="background: rgba(240, 16, 16, 0.5); cursor: pointer;" *ngIf="environment?.tag === 'DEV'">
    <div>
        <i class="pi pi-file-excel fs32 m5"></i>
    </div>

    <div class="ml16 mt8">
        <span style="font-size: 20px; font-weight: bold; margin-left: 8px">Download ROI report</span>
    </div>
</div>